import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu } from 'modules/actions/statusMenu';
import './style.scss';

const domainUrlParam = process.env.REACT_APP_DOMAIN_URL;

const ConversationGuide = () => {
  const dispatch = useDispatch();
  const closeConversationGuide = () => {
    dispatch(disableAllMenu());
  };
  const [displayStatus, setDisplayStatus] = useState({ help_content: true, guide_content: false });

  const changeDisplayHelp = () => {
    setDisplayStatus({ help_content: true, guide_content: false });
  };
  const changeDisplayGuide = () => {
    setDisplayStatus({ help_content: false, guide_content: true });
  };
  const tabRefs = useRef([]);
  useEffect(() => {
    if (tabRefs.current[0]) {
      tabRefs.current[0].focus();
    }
  }, []);
  const handleTabKeyDown = (e, tabIndex) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;

    e.preventDefault();
    const nextTabIndex = tabIndex === 0 ? 1 : 0;
    if (nextTabIndex === 0) changeDisplayHelp();
    else changeDisplayGuide();
    tabRefs.current[nextTabIndex].focus();
  };

  return (
    <div className="help_area">
      <div className="help_header">
        <span>대화 가이드</span>
        <button
          className="ri-close-line"
          type="button"
	  aria-label="대화 가이드 닫기"
          onClick={closeConversationGuide}
        />
      </div>
      <div className="help_tab_area" role="tablist" aria-label="대화 가이드 항목">
        <button
          type="button"
          className="help_tab"
          ref={element => { tabRefs.current[0] = element; }}
          role="tab"
          id="conversation-tip-tab"
          aria-selected={displayStatus.help_content}
          aria-controls="conversation-tip-panel"
          tabIndex={displayStatus.help_content ? 0 : -1}
          onClick={changeDisplayHelp}
          onKeyDown={e => handleTabKeyDown(e, 0)}
          style={{
            borderBottom: displayStatus.help_content ? '2px #BE314B solid' : '',
            color: displayStatus.help_content ? '#BE314B' : '',
            backgroundColor: displayStatus.help_content ? '#FFFFFF' : '#F5F5F5',
          }}
        >
          챗봇 활용팁
        </button>
        <button
          type="button"
          className="help_tab"
          ref={element => { tabRefs.current[1] = element; }}
          role="tab"
          id="satisfaction-guide-tab"
          aria-selected={displayStatus.guide_content}
          aria-controls="satisfaction-guide-panel"
          tabIndex={displayStatus.guide_content ? 0 : -1}
          onClick={changeDisplayGuide}
          onKeyDown={e => handleTabKeyDown(e, 1)}
          style={{
            borderBottom: displayStatus.guide_content ? '2px #BE314B solid' : '',
            color: displayStatus.guide_content ? '#BE314B' : '',
            backgroundColor: displayStatus.guide_content ? '#FFFFFF' : '#F5F5F5',
          }}
        >
          만족도 평가
        </button>
      </div>
      <div id="conversation-tip-panel" className="help_content" role="tabpanel" aria-labelledby="conversation-tip-tab" hidden={!displayStatus.help_content}>
        <div className="guide_title">챗봇 활용팁</div>
        <div className="guide_sub">
          챗봇 사용은 처음이신가요?
          <br />
          챗봇과 더 쉽게 대화하는 방법을 알려드릴게요!
        </div>
        <img
          src={`/${domainUrlParam}/ibricks/images/guide_03.png`}
          alt="챗봇 활용팁 1.챗봇은 간단명료한 말을 좋아해요. 예시) 무인민원발급기 위치 알려줘, 자동차 신규등록 2.대화를 처음부터 다시 하고 싶으신가요? 처음으로라고 입력해보세요. 상단 메뉴 또는 홈메뉴에서 처음으로 버튼을 누르셔도 돼요. 3.대화를 그만하고 싶으시다구요? 대화종료라고 입력해주세요. 서비스 향상을 위한 만족도 평가도 잊지 마세요. 기능과 메뉴에 대한 설명은 이용안내 메뉴에서 확인하실 수 있어요."
          className="img_help"
        />
      </div>

      <div id="satisfaction-guide-panel" className="help_content guide_content" role="tabpanel" aria-labelledby="satisfaction-guide-tab" hidden={!displayStatus.guide_content}>
        <div className="guide_title">만족도 평가</div>
        <div className="guide_sub">
          더욱 똑똑한 &apos;조아용&apos;으로 성장할 수 있도록
          <br />
          많은 관심과 의견 보내주세요!
        </div>

        <img
          src={`/${domainUrlParam}/ibricks/images/guide_04.png`}
          alt="만족도 평가 더욱똑똑한 조아용으로 성장할 수 있도록 많은 관심과 의견 보내주세요. 의견 남기기 버튼을 누르시면 응답에 대한 의견을 남길 수 있어요. 학습에 큰 도움이 됩니다. 챗봇 이용 후 만족도를 알려주세요. 별점 평가와 조아용에게 하고 싶은 말을 남겨주세요. 모두에게 매우 만족을 받는 날까지 노력할게요."
          className="img_help"
        />
      </div>
    </div>
  );
};

export default ConversationGuide;
